import React from "react";
import {Image} from 'react-bootstrap';
import {groupDefinitions, GroupId} from "./sharedConstants";

export const renderGroupIcon = (group: GroupId) => {
    let def = groupDefinitions[group];

    return <Image src={def.filename} rounded />
};
